import { render, staticRenderFns } from "./ExternalCguAgreement.vue?vue&type=template&id=d45ca55c&scoped=true"
import script from "./ExternalCguAgreement.vue?vue&type=script&lang=ts"
export * from "./ExternalCguAgreement.vue?vue&type=script&lang=ts"
import style0 from "./ExternalCguAgreement.vue?vue&type=style&index=0&id=d45ca55c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45ca55c",
  null
  
)

export default component.exports